import * as Sentry from "@sentry/react";
import { E as Environment } from "./environment-BHIxEh0R.js";
function getTracesSampleRate(environment) {
  const prodTracesSampleRate = 0.1;
  const nonProdTracesSampleRate = 1;
  return environment === Environment.PRODUCTION ? prodTracesSampleRate : nonProdTracesSampleRate;
}
const COLOR_ERROR_ID_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const getRandomErrorId = () => {
  let errorId = "";
  for (let i = 0; i < 6; i += 1) {
    if (i !== 0 && i % 2 === 0) {
      errorId += "-";
    }
    errorId += COLOR_ERROR_ID_CHARACTERS[Math.floor(Math.random() * COLOR_ERROR_ID_CHARACTERS.length)];
  }
  return errorId;
};
let latestColorErrorId = "";
function getLatestSentryEventId() {
  return latestColorErrorId;
}
function initSentry(environment, config) {
  const { dsn } = config;
  if (!dsn) {
    console.warn("Unable to determine Sentry DSN");
    return;
  }
  const sentryOptions = {
    ...config,
    environment,
    // `local`, `staging`, `testing`, `production`, or `unknown`
    integrations: [Sentry.browserTracingIntegration()],
    denyUrls: [/cdn\.cookielaw\.org/i],
    // Removed cookie consent dialog on the sites, but leaving this in case we add it back
    tracesSampleRate: getTracesSampleRate(environment),
    beforeSend: (event) => {
      const colorErrorId = getRandomErrorId();
      latestColorErrorId = colorErrorId;
      return {
        ...event,
        tags: {
          ...event.tags,
          colorErrorId
        }
      };
    }
  };
  Sentry.init(sentryOptions);
}
let monitoringIsInitialized = false;
function initMonitoring(monitoringConfig) {
  if (monitoringIsInitialized) {
    return;
  }
  monitoringIsInitialized = true;
  const { environment, sentryConfig } = monitoringConfig;
  initSentry(environment, sentryConfig);
}
function getInstrumentedApp(App, monitoringConfig) {
  initMonitoring(monitoringConfig);
  return Sentry.withProfiler(App);
}
export {
  getInstrumentedApp as a,
  getLatestSentryEventId as g,
  initMonitoring as i
};
//# sourceMappingURL=monitoring-36-CRZeW.js.map
